// The embed renders inside a shadow root but shares the host page's `window`,
// so `window.dataLayer` IS the GTM dataLayer on the NovoPsych landing page.
// Pushing here lets Marketing's GTM container fire the Google Ads conversion
// tag from a `jan_email_submit` trigger. No-op-safe when GTM isn't present.

export interface JanEmailSubmitEvent {
  variant: string;
  professionId: string;
}

/**
 * Announce a captured email lead to whatever tag manager the host page runs.
 * Fire once per successful email submit. Never throws — analytics must not
 * break the email-submit flow.
 */
export const pushJanEmailSubmit = ({
  variant,
  professionId,
}: JanEmailSubmitEvent): void => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "jan_email_submit",
      jan_variant: variant,
      jan_profession_id: professionId,
    });
  } catch {
    // Swallow — a failed analytics push must not surface to the user.
  }
};
